export const GET_RULE = 'V3GET_RULE';
export const GET_RULES = 'V3GET_RULES';
export const ARCHIVE_RULE = 'V3ARCHIVE_RULE';

export const EDIT_RULE = "V3_EDIT_RULE";
export const CREATE_RULE = "V3_CREATE_RULE";

export const SET_SELECTED_RULE_RULEID = "V3_SET_SELECTED_RULE_RULEID";
export const CLEAR_SELECTED_RULE_RULEID = "V3_CLEAR_SELECTED_RULE_RULEID";

export const GET_RULE_PARAMS = 'V3_GET_RULE_PARAMS'
export const GET_RULE_NOTIFICATION = 'V3_GET_RULE_NOTIFICATION'